import React, { createContext, useContext, useState } from "react";

const CarInfoContext = createContext();

export const useCarInfo = () => useContext(CarInfoContext);

export const CarInfoProvider = ({ children }) => {
  const [carInfo, setCarInfo] = useState({
    year: "",
    make: "",
    model: "",
    version: [],
    sellItForMe: [],
  });

  return (
    <CarInfoContext.Provider value={[carInfo, setCarInfo]}>
      {children}
    </CarInfoContext.Provider>
  );
};
